<router-outlet />
@defer (on idle; when hasToasts()) {
  <app-toast-host />
}
